import { gql } from '@apollo/client';
import appraiserFieldsFragment from '../../../../AppraiserForm/queries/appraiserFieldsFragment';

const appraiserAdminFieldsFragment = gql`
  fragment AppraiserAdminFields on AppraiserInfo {
    ...AppraiserFields
    AssignedAppraisals {
      Id
      Name
      AppraisalOrgUnits {
        MddapOrgUnits {
          Name
        }
      }
      IsCurrentAtlAutoAssigned
    }
  }
  ${appraiserFieldsFragment}
`;

export default appraiserAdminFieldsFragment;
